import { gql } from "@apollo/client";

export const GET_ZIPCODE_GEOFENCE_LISTING = gql`
    query GetZipcodeGeofenceListing($zipcode: String!) {
        getZipcodeGeofenceListing(zipcode: $zipcode) {
            id
            zipcode
            geometryType
            boundary
            notes
            status
            approvalComments
            descriptionType
            descriptionOther
            creatorId
            creatorName
            auditorId
            auditorName
            geofenceName
            geofenceType
            deliveredTotal
            warehouseName
            hubName
            createdAt
            updatedAt
        }
    }
`;

export interface ZipcodeMapGeofenceType {
    id?: number | null;
    zipcode: string;
    geometryType: string;
    boundary: string;
    notes?: string | null;
    status: string;
    approvalComments?: string | null;
    descriptionType: string;
    descriptionOther?: string | null;
    creatorId: number;
    creatorName?: string | null;
    auditorId?: number | null;
    auditorName?: string | null;
    geofenceName: string;
    geofenceType: string;
    deliveredTotal: number;
    warehouseName?: string | null;
    hubName?: string | null;
    createdAt: number;
    updatedAt: number;
}

export interface GetZipcodeGeofenceListingResponse {
    getZipcodeGeofenceListing: ZipcodeMapGeofenceType[];
}
